import goals from "../../../../src/components/content/goals/m9";
import * as React from 'react';
export default {
  goals,
  React
};